import { render, staticRenderFns } from "./RoleDetails.vue?vue&type=template&id=74b6fab6&scoped=true&"
import script from "./RoleDetails.vue?vue&type=script&lang=ts&"
export * from "./RoleDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b6fab6",
  null
  
)

/* custom blocks */
import block0 from "./RoleDetails.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports